import { put, takeEvery, delay } from 'redux-saga/effects';
import { removeMessage } from './messageActions';
import { ADD_MESSAGE } from './messageReducer';

function* delayRemoveMessage({ id }) {
  yield delay(10000);
  yield put(removeMessage(id));
}

function* waitForMessages() {
  yield takeEvery(ADD_MESSAGE, delayRemoveMessage);
}

export const messageSagas = [
  waitForMessages,
];
